import { getParamsFormObject } from 'utils';
import axiosClient from 'utils/axios';

const endPoint = '/landmarks';

export default {
  async getLandmarks(payload) {
    const params = getParamsFormObject(payload);
    const path = `${endPoint}${params}`;
    const response = await axiosClient.get(path);

    return response.data;
  },

  async createLandmark(payload) {
    const response = await axiosClient.post(endPoint, payload);

    return response.data;
  },

  async getLandmarkDetails(id) {
    const response = await axiosClient.get(`${endPoint}/${id}`);

    return response.data;
  },

  async updateLandmark(id, payload) {
    const response = await axiosClient.put(`${endPoint}/${id}`, payload);

    return response.data;
  },

  async deleteLandmark(id) {
    const response = await axiosClient.delete(`${endPoint}/${id}`);

    return response.data;
  },
};
